import { pageScrollBehavior } from "@/lib/scroll";
import { useState } from "react";
import { ArrowUpRight, Check } from "lucide-react";
import { useLocale } from "@/i18n/context";
import { PDFPreviewModal } from "@/components/PDFPreviewModal";
import { LogoIcon } from "@/components/ui/logo-icon";
import { trackCtaClick } from "@/lib/funnel";

export function ReportShowcase() {
  const { t } = useLocale();
  const [open, setOpen] = useState(false);
  return (
    <section className="report-showcase">
      <div className="container mx-auto px-5 sm:px-8">
        <div className="showcase-layout">
          <div className="showcase-spread" aria-hidden="true">
            <div className="showcase-page showcase-page-back"><div className="showcase-document-lines" /><div className="showcase-document-chart" /><div className="showcase-document-lines" /></div>
            <div className="showcase-page showcase-page-front">
              <LogoIcon className="h-7 w-7 text-primary" />
              <p className="mt-7 text-[9px] uppercase tracking-[.12em] text-muted-foreground">nreport / {t.brand.sampleLabel}</p>
              <h3 className="mt-2 text-xl font-semibold tracking-tight">Trubarjeva ulica 10</h3>
              <div className="mt-6 rounded-lg bg-[#EFF5E9] p-4"><p className="text-[9px] text-muted-foreground">{t.brand.estimate}</p><p className="mt-1 text-3xl font-semibold tracking-tight text-primary">227.964 €</p><div className="showcase-value-line" /></div>
              <div className="showcase-document-lines mt-7" />
              <div className="mt-6 border-t pt-3 text-[8px] leading-relaxed text-muted-foreground">{t.brand.sampleNote}</div>
            </div>
          </div>
          <div className="showcase-copy">
            <p className="editorial-eyebrow">{t.brand.previewEyebrow}</p>
            <h2 className="section-title mt-4">{t.brand.previewTitle}</h2>
            <p className="mt-5 leading-relaxed text-muted-foreground">{t.brand.previewDescription}</p>
            <ul className="my-7 space-y-3 text-sm text-foreground">
              {t.brand.previewPoints.map(point => <li key={point} className="flex items-start gap-3"><Check className="mt-0.5 h-4 w-4 shrink-0 text-primary" />{point}</li>)}
            </ul>
            <button type="button" className="inline-flex items-center gap-3 rounded-lg bg-primary px-5 py-3 text-sm font-semibold text-white transition-colors hover:bg-primary-hover focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2" onClick={() => { trackCtaClick("report_showcase_preview"); setOpen(true); }}>
              {t.hero.ctaPreview}<ArrowUpRight className="h-4 w-4" />
            </button>
            <p className="mt-4 text-xs text-muted-foreground">{t.brand.previewLanguage}</p>
          </div>
        </div>
      </div>
      <PDFPreviewModal isOpen={open} onClose={() => setOpen(false)} onOrderReport={() => { setOpen(false); document.getElementById("pricing")?.scrollIntoView({ behavior: pageScrollBehavior() }); }} />
    </section>
  );
}
